import * as React from "react"
import { styled } from "../../../stitches.config";

const MarginWrapper: React.FunctionComponent<React.PropsWithChildren> = ({ children }) => (<Wrapper>{children}</Wrapper>)

const Wrapper = styled("div",{
    marginTop: "18px"
});

export default MarginWrapper